import {useEffect} from "react";

import {GuideStateApi} from "@khan/guide-state";

import {useGuideSwagApplied} from "../queries/use-guide-swag-applied.ts";

/**
 * Load the user's preferred appearance for AI Guide.
 */
export const useGuideAppearanceSyncEffect = (): void => {
    const result = useGuideSwagApplied();
    useEffect(() => {
        if (result.status === "success") {
            GuideStateApi.set("swagId", result.data ?? "default");
        }
    }, [result]);
};
